import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardLayout from "@/pages/DashboardLayout";
import Overview from "@/pages/Overview";
import BrandInfo from "@/pages/BrandInfo";
import Catalog from "@/pages/Catalog";
import Locations from "@/pages/Locations";
import Questions from "@/pages/Questions";
import Experiences from "@/pages/Experiences";
import Analytics from "@/pages/Analytics";
import Kiosk from "@/pages/Kiosk";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafafa]">
        <div className="label-overline">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="light" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/kiosk/:token" element={<Kiosk />} />

          <Route
            path="/dashboard"
            element={
              <Protected>
                <DashboardLayout />
              </Protected>
            }
          >
            <Route index element={<Overview />} />
            <Route path="brand" element={<BrandInfo />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="locations" element={<Locations />} />
            <Route path="questions" element={<Questions />} />
            <Route path="experiences" element={<Experiences />} />
            <Route path="analytics" element={<Analytics />} />
          </Route>

          <Route
            path="/admin"
            element={
              <Protected>
                <Admin />
              </Protected>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
